module.exports = __webpack_public_path__ + "static/media/oneHundredOff_326.4815d22c.png";